import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { projektApiUrl } from '../tokens/projekt-api-url-token';
import { Observable } from 'rxjs';
import {
  GetSignedDocumentResponse,
  SigneringStatusResponse,
} from '../services/signering.service';

@Injectable({
  providedIn: 'root',
})
export class SigneringClient {
  private projektApiUrl = inject<string>(projektApiUrl);
  private httpClient = inject(HttpClient);

  createSignering(
    command: CreateSigneringCommand,
  ): Observable<{ redirectUrl: string }> {
    const url = `${this.projektApiUrl}/Signering/create`;
    return this.httpClient.post<{ redirectUrl: string }>(url, command);
  }

  getSigneringStatus(rapportId: string): Observable<SigneringStatusResponse> {
    const url = `${this.projektApiUrl}/Signering/status?RapportId=${rapportId}`;
    return this.httpClient.get<SigneringStatusResponse>(url);
  }

  getSignedDocument(rapportId: string): Observable<GetSignedDocumentResponse> {
    const url = `${this.projektApiUrl}/Signering/getSignedDocument?RapportId=${rapportId}`;
    return this.httpClient.get<GetSignedDocumentResponse>(url);
  }

  deleteSignedDocument(rapportId: string): void {
    const url = `${this.projektApiUrl}/Signering/deleteSignedDocument?RapportId=${rapportId}`;
    this.httpClient.delete<void>(url).subscribe();
  }
}

export type CreateSigneringCommand = {
  rapportId?: string;
  language?: string;
};
